<template>
  <div style="height: 100%;width: 100%">
    <h2>{{ $t('makeSchedule.processProductionSchedulingCalendar.productionScheduleCalendar') }}</h2>
    <el-container style="height: 95%;width: 100%">
      <el-aside width="68%" class="border" style="height: 100%">
        <el-calendar class="el-calendar" v-model="value" ref="calendar">
          <template #header="{ date }">
            <span></span>
            <h2 style="font-size: 25px">{{ date }}</h2>
            <el-button-group>
              <el-button style="font-size: 20px" @click="selectDate('prev-month')"><el-icon><ElIconArrowLeft /></el-icon></el-button>
              <el-button style="font-size: 18px" @click="selectDate('today')">今</el-button>
              <el-button style="font-size: 20px" @click="selectDate('next-month')"><el-icon><ElIconArrowRight /></el-icon></el-button>
            </el-button-group>
          </template>
          <template #date-cell="{ data }">
            <div :class="data.isSelected ?'dateDiv_1':'dateDiv'" :dataInfo="item=showWorkDate(data.day)" @click="confirmValue(data.day)">
              <text :class="data.isSelected ? 'is-selected' : ''" v-if="data.type === 'current-month'" class="dayDiv">
                {{ data.day.split('-').slice(2).join() >= 10 ? data.day.split('-').slice(2).join() : data.day.split('-').slice(2).join().replace(0, '') }}
              </text>
              <div class="div-text">
                <text class="workDiv" v-if="item.work_type==='work' && data.type === 'current-month'">{{ "班" }}</text>
                <text class="holidayDiv" v-if="item.work_type==='holiday' && data.type === 'current-month'">{{"节"}}</text>
                <text class="restDiv" v-if="item.work_type==='weekend' && data.type === 'current-month'">{{"休"}}</text>
              </div>

              <div class="row" v-if="data.type === 'current-month'">
                <div :class="item.day_shift_line_1 == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_1 ? '1' : '' }}</div>
                <div :class="item.day_shift_line_2 == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_2 ? '2' : '' }}</div>
                <div :class="item.day_shift_line_3 == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_3 ? '3' : '' }}</div>
                <div :class="item.day_shift_line_4 == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_4 ? '4' : '' }}</div>
                <div :class="item.day_shift_line_5 == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_5 ? '5' : '' }}</div>
                <div :class="item.day_shift_line_6 == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_6 ? '6' : '' }}</div>
              </div>

              <div class="row" v-if="data.type === 'current-month'">
                <div :class="item.night_shift_line_1 == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_1 ? '1' : '' }}</div>
                <div :class="item.night_shift_line_2 == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_2 ? '2' : '' }}</div>
                <div :class="item.night_shift_line_3 == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_3 ? '3' : '' }}</div>
                <div :class="item.night_shift_line_4 == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_4 ? '4' : '' }}</div>
                <div :class="item.night_shift_line_5 == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_5 ? '5' : '' }}</div>
                <div :class="item.night_shift_line_6 == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_6 ? '6' : '' }}</div>
              </div>
            </div>
          </template>
        </el-calendar>
      </el-aside>
      <div style="width: 1%"></div>
      <el-container style="height: 100%;width: 32%">
        <h2 style="margin-top: -33px">{{ $t('makeSchedule.processProductionSchedulingCalendar.todayDetails') }}</h2>
        <el-header height="46%" style="overflow-y: auto" class="border">
          <div style="font-size: 25px;text-align: center;margin-top: 4%;color: rgb(4, 134, 254)">{{ selectedYear }}
            <span style="color: black;font-size: 20px">年&nbsp;</span>{{ selectedMonth }}
            <span style="color: black;font-size: 20px">月&nbsp;</span>{{ selectedDay }}
            <span style="color: black;font-size: 20px">日</span>
          </div>
          <div style="font-size: 20px;text-align: center;">{{ selectedWeek }}</div>
          <div style="text-align: center;margin-top: 3%;margin-left:-8px;font-size: 20px">
            <span>类型：</span>
            <el-button-group>
              <el-button :type="dateButtonTypeClass" class="date_button" v-model="dateButtonModel"
                         @click="dateButtonClass(dateButtonModelClass)" style="width: 95px;">班
              </el-button>
              <el-button :type="dateButtonTypeStop" class="date_button" v-model="dateButtonModel"
                         @click="dateButtonStop(dateButtonModelStop)" style="width: 95px;">休
              </el-button>
              <el-button :type="dateButtonTypeJoint" class="date_button" v-model="dateButtonModel"
                         @click="dateButtonJoint(dateButtonModelJoint)" style="width: 95px;">节
              </el-button>
            </el-button-group>
          </div>
          <div style="margin-top: 3%;" class="row">
            <span>{{ $t('makeSchedule.processProductionSchedulingCalendar.dayShift') }}：</span>
            <div @click="dayShiftButton1"
                 :class="dayShift.dayShiftButtonBool1? 'day_shift_button_true' : 'day_shift_button_false'">1
            </div>
            <div @click="dayShiftButton2"
                 :class="dayShift.dayShiftButtonBool2? 'day_shift_button_true' : 'day_shift_button_false'">2
            </div>
            <div @click="dayShiftButton3"
                 :class="dayShift.dayShiftButtonBool3? 'day_shift_button_true' : 'day_shift_button_false'">3
            </div>
            <div @click="dayShiftButton4"
                 :class="dayShift.dayShiftButtonBool4? 'day_shift_button_true' : 'day_shift_button_false'">4
            </div>
            <div @click="dayShiftButton5"
                 :class="dayShift.dayShiftButtonBool5? 'day_shift_button_true' : 'day_shift_button_false'">5
            </div>
            <div @click="dayShiftButton6"
                 :class="dayShift.dayShiftButtonBool6? 'day_shift_button_true' : 'day_shift_button_false'">6
            </div>
          </div>
          <div style="margin-top: 3%;" class="row">
            <span>{{ $t('makeSchedule.processProductionSchedulingCalendar.nightShift') }}：</span>
            <div @click="nightShiftButton1"
                 :class="nightShift.nightShiftButtonBool1? 'night_shift_button_true' : 'night_shift_button_false'">1
            </div>
            <div @click="nightShiftButton2"
                 :class="nightShift.nightShiftButtonBool2? 'night_shift_button_true' : 'night_shift_button_false'">2
            </div>
            <div @click="nightShiftButton3"
                 :class="nightShift.nightShiftButtonBool3? 'night_shift_button_true' : 'night_shift_button_false'">3
            </div>
            <div @click="nightShiftButton4"
                 :class="nightShift.nightShiftButtonBool4? 'night_shift_button_true' : 'night_shift_button_false'">4
            </div>
            <div @click="nightShiftButton5"
                 :class="nightShift.nightShiftButtonBool5? 'night_shift_button_true' : 'night_shift_button_false'">5
            </div>
            <div @click="nightShiftButton6"
                 :class="nightShift.nightShiftButtonBool6? 'night_shift_button_true' : 'night_shift_button_false'">6
            </div>
          </div>
          <div style="text-align: center;margin-top: 5%;">
            <el-button style="width: 100px;height: 35px" type="primary" :loading="loading" @click="buttonClick">保存</el-button>
          </div>
        </el-header>
        <h2 style="display:flex;margin: 10px 0;">{{ $t('makeSchedule.processProductionSchedulingCalendar.batchManagement') }}</h2>
        <el-main height="54%" class="border">
          <div style="text-align: center;margin-top: 2%">
            <span style="font-size: 20px;">日期：</span>
            <el-date-picker style="width: 290px" v-model="dateInterval" value-format="YYYY-MM-DD" type="daterange"
                            range-separator="~" start-placeholder="开始时间" end-placeholder="结束时间"/>
          </div>
          <div style="margin-top: 3%;text-align: center;margin-left: -12px">
            <span style="font-size: 20px">{{ $t('makeSchedule.processProductionSchedulingCalendar.onlyModifyTheWeek') }}：</span>
            <el-checkbox style="width: 4%"  v-model="checkList[1].checkBox1" :label="$t('makeSchedule.processProductionSchedulingCalendar.one')" />
            <el-checkbox style="width: 4%"  v-model="checkList[2].checkBox2" :label="$t('makeSchedule.processProductionSchedulingCalendar.two')" />
            <el-checkbox style="width: 4%"  v-model="checkList[3].checkBox3" :label="$t('makeSchedule.processProductionSchedulingCalendar.three')" />
            <el-checkbox style="width: 4%"  v-model="checkList[4].checkBox4" :label="$t('makeSchedule.processProductionSchedulingCalendar.four')" />
            <el-checkbox style="width: 4%"  v-model="checkList[5].checkBox5" :label="$t('makeSchedule.processProductionSchedulingCalendar.five')" />
            <el-checkbox style="width: 4%"  v-model="checkList[6].checkBox6" :label="$t('makeSchedule.processProductionSchedulingCalendar.six')" />
              <el-checkbox style="width: 4%"  v-model="checkList[0].checkBox0" label="日" />
          </div>
          <div style="margin-top: 3%" class="row">
            <span style="font-size: 20px">{{ $t('makeSchedule.processProductionSchedulingCalendar.dayShift') }}：</span>
            <div @click="dayShiftBatchButton1"
                 :class="dayShiftBatch.dayShiftButtonBool1? 'day_shift_button_true' : 'day_shift_button_false'">1
            </div>
            <div @click="dayShiftBatchButton2"
                 :class="dayShiftBatch.dayShiftButtonBool2? 'day_shift_button_true' : 'day_shift_button_false'">2
            </div>
            <div @click="dayShiftBatchButton3"
                 :class="dayShiftBatch.dayShiftButtonBool3? 'day_shift_button_true' : 'day_shift_button_false'">3
            </div>
            <div @click="dayShiftBatchButton4"
                 :class="dayShiftBatch.dayShiftButtonBool4? 'day_shift_button_true' : 'day_shift_button_false'">4
            </div>
            <div @click="dayShiftBatchButton5"
                 :class="dayShiftBatch.dayShiftButtonBool5? 'day_shift_button_true' : 'day_shift_button_false'">5
            </div>
            <div @click="dayShiftBatchButton6"
                 :class="dayShiftBatch.dayShiftButtonBool6? 'day_shift_button_true' : 'day_shift_button_false'">6
            </div>
          </div>
          <div style="margin-top: 3%" class="row">{{ $t('makeSchedule.processProductionSchedulingCalendar.nightShift') }}：
            <div @click="nightShiftBatchButton1"
                 :class="nightShiftBatch.nightShiftButtonBool1? 'night_shift_button_true' : 'night_shift_button_false'">
              1
            </div>
            <div @click="nightShiftBatchButton2"
                 :class="nightShiftBatch.nightShiftButtonBool2? 'night_shift_button_true' : 'night_shift_button_false'">
              2
            </div>
            <div @click="nightShiftBatchButton3"
                 :class="nightShiftBatch.nightShiftButtonBool3? 'night_shift_button_true' : 'night_shift_button_false'">
              3
            </div>
            <div @click="nightShiftBatchButton4"
                 :class="nightShiftBatch.nightShiftButtonBool4? 'night_shift_button_true' : 'night_shift_button_false'">
              4
            </div>
            <div @click="nightShiftBatchButton5"
                 :class="nightShiftBatch.nightShiftButtonBool5? 'night_shift_button_true' : 'night_shift_button_false'">
              5
            </div>
            <div @click="nightShiftBatchButton6"
                 :class="nightShiftBatch.nightShiftButtonBool6? 'night_shift_button_true' : 'night_shift_button_false'">
              6
            </div>
          </div>

          <div style="text-align: center;margin-top: 5%">
            <el-button style="width: 100px;height: 35px" type="primary" :loading="batchLoading" @click="batchButtonClick">保存
            </el-button>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "AssemblyProductionSchedulingCalendar",
  data() {
    return {
      value: new Date(),
      dateMap: [],
      selectedYear: '', //年
      selectedWeek: '', //周
      selectedMonth: '',//月
      selectedDay: '',//天
      radio: '',
      confirmBool:false,
      //以下处理类型
      dateButtonModel: '',
      dateButtonModelClass: 'work',
      dateButtonModelStop: 'weekend',
      dateButtonModelJoint: 'holiday',
      dateButtonTypeClass: '',
      dateButtonTypeStop: '',
      dateButtonTypeJoint: '',
      //只修改周
      checkList: [
        {checkBox0: false},
        {checkBox1: true},
        {checkBox2: true},
        {checkBox3: true},
        {checkBox4: true},
        {checkBox5: true},
        {checkBox6: true}
      ],
      //以下处理白班
      dayShift: {
        dayShiftButtonBool1: false,
        dayShiftButtonBool2: false,
        dayShiftButtonBool3: false,
        dayShiftButtonBool4: false,
        dayShiftButtonBool5: false,
        dayShiftButtonBool6: false
      },
      dayShiftBatch: {
        dayShiftButtonBool1: false,
        dayShiftButtonBool2: false,
        dayShiftButtonBool3: false,
        dayShiftButtonBool4: false,
        dayShiftButtonBool5: false,
        dayShiftButtonBool6: false
      },
      //以下处理夜班
      nightShift: {
        nightShiftButtonBool1: false,
        nightShiftButtonBool2: false,
        nightShiftButtonBool3: false,
        nightShiftButtonBool4: false,
        nightShiftButtonBool5: false,
        nightShiftButtonBool6: false
      },
      nightShiftBatch: {
        nightShiftButtonBool1: false,
        nightShiftButtonBool2: false,
        nightShiftButtonBool3: false,
        nightShiftButtonBool4: false,
        nightShiftButtonBool5: false,
        nightShiftButtonBool6: false
      },
      loading: false,
      batchLoading: false,
      dateInterval: '',
    }
  }, methods: {
    //清除批量值
    clearData() {
      this.dateInterval = '';
      this.nightShiftBatch.nightShiftButtonBool1 = false;
      this.nightShiftBatch.nightShiftButtonBool2 = false;
      this.nightShiftBatch.nightShiftButtonBool3 = false;
      this.nightShiftBatch.nightShiftButtonBool4 = false;
      this.nightShiftBatch.nightShiftButtonBool5 = false;
      this.nightShiftBatch.nightShiftButtonBool6 = false;
      this.dayShiftBatch.dayShiftButtonBool1 = false;
      this.dayShiftBatch.dayShiftButtonBool2 = false;
      this.dayShiftBatch.dayShiftButtonBool3 = false;
      this.dayShiftBatch.dayShiftButtonBool4 = false;
      this.dayShiftBatch.dayShiftButtonBool5 = false;
      this.dayShiftBatch.dayShiftButtonBool6 = false;
    },
    //total查询 组件自带
    selectDate(value) {
      this.$refs.calendar.selectDate(value)
      this.getWorkDateList(this.value)
      let day = moment(this.value).format("YYYY-MM-DD")
      this.timer1 = setTimeout(() => {
        this.confirmValue(day)
      }, 200)

    },
    getWorkDateList(date) {
      let params = {work_date: date}
      this.$axios.post('mfg/assemblyCalendar/selectMonthData', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.$message.error("获取数据失败");
        }
        this.dateMap = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //显示工作日 日期
    showWorkDate(day) {
      if (this.dateMap[day]) {
        return this.dateMap[day]
      }
      return ""
    },
    //填充当日详情数据
    confirmValue(value) {
      console.log("day==",value)
      this.confirmBool = true;
      const weeks = ['一', '二', '三', '四', '五', '六', '日']
      let date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.selectedYear = year
      this.selectedMonth = month;
      this.selectedDay = day;
      this.selectedWeek = "周" + weeks[date.getDay() - 1];
      if (date.getDay() == 0) {
        this.selectedWeek = "周" + weeks[6];
      }

      if (this.dateMap[value] !== undefined) {
        let item = this.dateMap[value];
        if (item.work_type === 'work') {
          this.dateButtonTypeClass = 'primary'
          this.dateButtonTypeStop = ''
          this.dateButtonTypeJoint = ''
          this.dateButtonModel = 'work'
        } else if (item.work_type === 'weekend') {
          this.dateButtonTypeStop = 'primary'
          this.dateButtonTypeClass = ''
          this.dateButtonTypeJoint = ''
          this.dateButtonModel = 'weekend';
        } else if (item.work_type === 'holiday') {
          this.dateButtonTypeStop = ''
          this.dateButtonTypeClass = ''
          this.dateButtonTypeJoint = 'primary'
          this.dateButtonModel = 'holiday';
        }

        this.dayShift.dayShiftButtonBool1 = item.day_shift_line_1;
        this.dayShift.dayShiftButtonBool2 = item.day_shift_line_2;
        this.dayShift.dayShiftButtonBool3 = item.day_shift_line_3;
        this.dayShift.dayShiftButtonBool4 = item.day_shift_line_4;
        this.dayShift.dayShiftButtonBool5 = item.day_shift_line_5;
        this.dayShift.dayShiftButtonBool6 = item.day_shift_line_6;

        this.nightShift.nightShiftButtonBool1 = item.night_shift_line_1;
        this.nightShift.nightShiftButtonBool2 = item.night_shift_line_2;
        this.nightShift.nightShiftButtonBool3 = item.night_shift_line_3;
        this.nightShift.nightShiftButtonBool4 = item.night_shift_line_4;
        this.nightShift.nightShiftButtonBool5 = item.night_shift_line_5;
        this.nightShift.nightShiftButtonBool6 = item.night_shift_line_6;
      }
    },
    //班休节 按钮
    dateButtonClass(dateButtonModel) {
      let day = moment(this.value).format("YYYY-MM-DD")
      this.confirmValue(day)
      this.dateButtonModel = dateButtonModel;
      this.dateButtonTypeClass = 'primary'
      this.dateButtonTypeStop = ''
      this.dateButtonTypeJoint = ''
    },
    dateButtonStop(dateButtonModel) {
      this.dayShift.dayShiftButtonBool1 = false;
      this.dayShift.dayShiftButtonBool2 = false;
      this.dayShift.dayShiftButtonBool3 = false;
      this.dayShift.dayShiftButtonBool4 = false;
      this.dayShift.dayShiftButtonBool5 = false;
      this.dayShift.dayShiftButtonBool6 = false;

      this.nightShift.nightShiftButtonBool1 = false;
      this.nightShift.nightShiftButtonBool2 = false;
      this.nightShift.nightShiftButtonBool3 = false;
      this.nightShift.nightShiftButtonBool4 = false;
      this.nightShift.nightShiftButtonBool5 = false;
      this.nightShift.nightShiftButtonBool6 = false;
      this.dateButtonModel = dateButtonModel;
      this.dateButtonTypeClass = ''
      this.dateButtonTypeStop = 'primary'
      this.dateButtonTypeJoint = ''
    },
    dateButtonJoint(dateButtonModel) {
      this.dayShift.dayShiftButtonBool1 = false;
      this.dayShift.dayShiftButtonBool2 = false;
      this.dayShift.dayShiftButtonBool3 = false;
      this.dayShift.dayShiftButtonBool4 = false;
      this.dayShift.dayShiftButtonBool5 = false;
      this.dayShift.dayShiftButtonBool6 = false;

      this.nightShift.nightShiftButtonBool1 = false;
      this.nightShift.nightShiftButtonBool2 = false;
      this.nightShift.nightShiftButtonBool3 = false;
      this.nightShift.nightShiftButtonBool4 = false;
      this.nightShift.nightShiftButtonBool5 = false;
      this.nightShift.nightShiftButtonBool6 = false;
      this.dateButtonModel = dateButtonModel;
      this.dateButtonTypeClass = ''
      this.dateButtonTypeStop = ''
      this.dateButtonTypeJoint = 'primary'
    },
    //白班 按钮
    dayShiftButton1() {
      if (this.dayShift.dayShiftButtonBool1) {
        this.dayShift.dayShiftButtonBool1 = false;
      } else {
        this.dayShift.dayShiftButtonBool1 = true;
      }
    },
    dayShiftButton2() {
      if (this.dayShift.dayShiftButtonBool2) {
        this.dayShift.dayShiftButtonBool2 = false;
      } else {
        this.dayShift.dayShiftButtonBool2 = true;
      }
    },
    dayShiftButton3() {
      if (this.dayShift.dayShiftButtonBool3) {
        this.dayShift.dayShiftButtonBool3 = false;
      } else {
        this.dayShift.dayShiftButtonBool3 = true;
      }
    },
    dayShiftButton4() {
      if (this.dayShift.dayShiftButtonBool4) {
        this.dayShift.dayShiftButtonBool4 = false;
      } else {
        this.dayShift.dayShiftButtonBool4 = true;
      }
    },
    dayShiftButton5() {
      if (this.dayShift.dayShiftButtonBool5) {
        this.dayShift.dayShiftButtonBool5 = false;
      } else {
        this.dayShift.dayShiftButtonBool5 = true;
      }
    },
    dayShiftButton6() {
      if (this.dayShift.dayShiftButtonBool6) {
        this.dayShift.dayShiftButtonBool6 = false;
      } else {
        this.dayShift.dayShiftButtonBool6 = true;
      }
    },
    // 夜班 按钮
    nightShiftButton1() {
      if (this.nightShift.nightShiftButtonBool1) {
        this.nightShift.nightShiftButtonBool1 = false;
      } else {
        this.nightShift.nightShiftButtonBool1 = true;
      }
    },
    nightShiftButton2() {
      if (this.nightShift.nightShiftButtonBool2) {
        this.nightShift.nightShiftButtonBool2 = false;
      } else {
        this.nightShift.nightShiftButtonBool2 = true;
      }
    },
    nightShiftButton3() {
      if (this.nightShift.nightShiftButtonBool3) {
        this.nightShift.nightShiftButtonBool3 = false;
      } else {
        this.nightShift.nightShiftButtonBool3 = true;
      }
    },
    nightShiftButton4() {
      if (this.nightShift.nightShiftButtonBool4) {
        this.nightShift.nightShiftButtonBool4 = false;
      } else {
        this.nightShift.nightShiftButtonBool4 = true;
      }
    },
    nightShiftButton5() {
      if (this.nightShift.nightShiftButtonBool5) {
        this.nightShift.nightShiftButtonBool5 = false;
      } else {
        this.nightShift.nightShiftButtonBool5 = true;
      }
    },
    nightShiftButton6() {
      if (this.nightShift.nightShiftButtonBool6) {
        this.nightShift.nightShiftButtonBool6 = false;
      } else {
        this.nightShift.nightShiftButtonBool6 = true;
      }
    },
    dayShiftBatchButton1() {
      if (this.dayShiftBatch.dayShiftButtonBool1) {
        this.dayShiftBatch.dayShiftButtonBool1 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool1 = true;
      }
    },
    dayShiftBatchButton2() {
      if (this.dayShiftBatch.dayShiftButtonBool2) {
        this.dayShiftBatch.dayShiftButtonBool2 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool2 = true;
      }
    },
    dayShiftBatchButton3() {
      if (this.dayShiftBatch.dayShiftButtonBool3) {
        this.dayShiftBatch.dayShiftButtonBool3 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool3 = true;
      }
    },
    dayShiftBatchButton4() {
      if (this.dayShiftBatch.dayShiftButtonBool4) {
        this.dayShiftBatch.dayShiftButtonBool4 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool4 = true;
      }
    },
    dayShiftBatchButton5() {
      if (this.dayShiftBatch.dayShiftButtonBool5) {
        this.dayShiftBatch.dayShiftButtonBool5 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool5 = true;
      }
    },
    dayShiftBatchButton6() {
      if (this.dayShiftBatch.dayShiftButtonBool6) {
        this.dayShiftBatch.dayShiftButtonBool6 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool6 = true;
      }
    },
    // 夜班 按钮
    nightShiftBatchButton1() {
      if (this.nightShiftBatch.nightShiftButtonBool1) {
        this.nightShiftBatch.nightShiftButtonBool1 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool1 = true;
      }
    },
    nightShiftBatchButton2() {
      if (this.nightShiftBatch.nightShiftButtonBool2) {
        this.nightShiftBatch.nightShiftButtonBool2 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool2 = true;
      }
    },
    nightShiftBatchButton3() {
      if (this.nightShiftBatch.nightShiftButtonBool3) {
        this.nightShiftBatch.nightShiftButtonBool3 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool3 = true;
      }
    },
    nightShiftBatchButton4() {
      if (this.nightShiftBatch.nightShiftButtonBool4) {
        this.nightShiftBatch.nightShiftButtonBool4 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool4 = true;
      }
    },
    nightShiftBatchButton5() {
      if (this.nightShiftBatch.nightShiftButtonBool5) {
        this.nightShiftBatch.nightShiftButtonBool5 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool5 = true;
      }
    },
    nightShiftBatchButton6() {
      if (this.nightShiftBatch.nightShiftButtonBool6) {
        this.nightShiftBatch.nightShiftButtonBool6 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool6 = true;
      }
    },
    buttonClick() {
      if (!this.dateButtonModel) {
        return this.$message.error("类型不能为空！");
      }

      this.loading = true;
      let params = {dayShiftData: this.dayShift, nightShiftData: this.nightShift, type: this.dateButtonModel, date:this.value}
      this.$axios.post('mfg/assemblyCalendar/updateDayDetail', params).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.$message.success("修改成功");
        this.getWorkDateList(this.value);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })

    },
    batchButtonClick() {
      if (!this.dateInterval) {
        return this.$message.error("日期不能为空！");
      }

      this.batchLoading = true;
      let params = {dayShiftBatchData: this.dayShiftBatch, nightShiftBatchData: this.nightShiftBatch, dateList:this.dateInterval, checkList:this.checkList}
      this.$axios.post('mfg/assemblyCalendar/batchUpdateWorkDate', params).then(response => {
        this.batchLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.clearData()
        this.$message.success("批量修改成功");
        this.getWorkDateList(this.value);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    }
  }, created() {
    this.getWorkDateList(this.value)
    this.timer1 = setTimeout(() => {
      let day = moment(this.value).format("YYYY-MM-DD")
      this.confirmValue(day)
    }, 200)
  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.is-selected {
  color: #1989fa;
}

.border :deep(.el-calendar-day) {
  box-sizing: border-box;
  padding: 0;
  height: 100%;
}

.dayDiv {
  font-size: 25px;
}

.dateDiv {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


.dateDiv_1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #c9f5cb;
}

.div-text {
  width: 45px;
  height: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  margin-bottom: 8px;
}


.restDiv {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  color: #909399;
  background-color: #e5e5e5;
}

.workDiv {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #0486fe;
}

.holidayDiv {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #42b983;
}

.date_button {
  margin-left: 0;
}

.day_shift_type_true {
  padding: 0;
  border-radius: 0;
  width: 13%;
  line-height: 18px;
  height: 18px;
  background-color: #0486fe;
  color: white;
  text-align: center;
  font-size: 18px;
  margin-left: 4px;
  margin-bottom: 3px;
}

.day_shift_type_false {
  padding: 0;
  border-radius: 0;
  width: 13%;
  line-height: 18px;
  text-align: center;
  border: #0486fe 1px dashed;
  margin-left: 4px;
  margin-bottom: 3px;
  height: 18px;
}

.night_shift_type_true {
  padding: 0;
  border-radius: 0;
  width: 13%;
  line-height: 18px;
  background-color: #223342;
  color: white;
  font-size: 18px;
  margin-left: 4px;
  text-align: center;
}

.night_shift_type_false {
  padding: 0;
  border-radius: 0;
  width: 13%;
  line-height: 18px;
  border: #223342 1px dashed;
  font-size: 18px;
  margin-left: 4px;
  text-align: center;
  height: 18px;
}

.day_shift_button_false {
  width: 40px;
  height: 50px;
  border-radius: 0;
  border: 1px #0486fe dashed;
  line-height: 50px;
  margin-right: 9px;
  text-align: center;
}

.day_shift_button_true {
  width: 40px;
  height: 50px;
  border-radius: 0;
  background-color: #0486fe;
  line-height: 50px;
  margin-right: 9px;
  text-align: center;
  color: white;
}

.night_shift_button_false {
  width: 40px;
  height: 50px;
  border-radius: 0;
  line-height: 50px;
  margin-right: 9px;
  text-align: center;
  border: 1px #223342 dashed;
}

.night_shift_button_true {
  width: 40px;
  height: 50px;
  border-radius: 0;
  line-height: 50px;
  margin-right: 9px;
  text-align: center;
  background-color: #223342;
  color: white;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  width: 100%;
  height: auto;
}

/*.border :deep(.el-calendar__body) {*/
/*  padding: 0;*/
/*}*/


</style>